<template>
    <form id="mainForm" action="#" method="post">
        <Card>
            <template #title>
                <Toolbar>
                    <template #left>
                        <div class="p-card-title">Appraisal Report</div>
                    </template>
                </Toolbar>
            </template>
            <template #content>
                <div style="font-style: italic;color:red;">{{ $t('auth_report') }}
                    <Button :label="$t('click_here')" class="p-button p-component p-button-link"
                        @click="showReportAuth()"
                        style="color: red;margin-bottom: -7px;margin-left: -10px;font-weight: bold;font-style: italic;text-decoration: underline;" />
                </div>
                <div v-if="header && this.Error_Message && !this.submitted">
                    <Message severity="warn" :closable="false" v-html="this.Error_Message">
                    </Message>
                </div>
                <div class="p-inputtext-sm p-fluid">
                    <div class="grid">
                        <div class="col-6">
                            <div class="field grid">
                                <label for="Unit_Code" class="col-4">{{ $t('unit') }}</label>
                                <div class="col-8 md-8">
                                    <CustomMultiSelect class="p-inputtext-sm" v-model="UnitCode" type="text"
                                        placeholder="All" :url="this.$API_URL + 'list/unit_code'" :minLength="0"
                                        :params="{}" :filter="true" :optionValue="'id'" :optionLabel="'text'" />
                                </div>
                            </div>
                            <div class="field grid">
                                <label for="Functional_Code" class="col-4">{{ $t('functional') }}</label>
                                <div class="col-8 md-8">
                                    <CustomMultiSelect class="p-inputtext-sm" v-model="FunctionalCode" type="text"
                                        placeholder="All" :url="this.$API_URL + 'list/functional_code'" :minLength="0"
                                        :params="{}" :filter="true" :optionValue="'id'" :optionLabel="'text'" />
                                </div>
                            </div>
                            <div class="field grid">
                                <label for="Department_Code" class="col-4">{{ $t('department') }}</label>
                                <div class="col-8 md-8">
                                    <CustomMultiSelect class="p-inputtext-sm" v-model="DepartmentCode" type="text"
                                        placeholder="All" :url="this.$API_URL + 'list/department_code'" :minLength="0"
                                        :params="{}" :filter="true" :optionValue="'id'" :optionLabel="'text'" />
                                </div>
                            </div>
                            <div class="field grid">
                                <label for="Grade_Code" class="col-4">{{ $t('grade') }}</label>
                                <div class="col-8 md-8">
                                    <CustomMultiSelect class="p-inputtext-sm" v-model="this.GradeCode" type="text"
                                        placeholder="All" :url="this.$API_URL + 'list/grade_code'" :minLength="0"
                                        :params="{}" :filter="true" :optionValue="'id'" />
                                </div>
                            </div>
                            <!-- <div class="field grid">
                                <label for="Section_Code" class="col-4">{{ $t('section') }}</label>
                                <div class="col-8 md-8">
                                    <CustomMultiSelect class="p-inputtext-sm" v-model="SectionCode" type="text"
                                        placeholder="All" :url="this.$API_URL + 'list/section_code'" :minLength="0"
                                        :params="{}" :filter="true" :optionValue="'id'" :optionLabel="'text'" />
                                </div>
                            </div> -->
                            <div class="field grid">
                                <label for="Grade_Type" class="col-4">{{ $t('appraisal_type') }}</label>
                                <div class="col-8 md-8">
                                    <CustomSelect class="p-inputtext-sm" v-model="Appraisal_Type" :filter="true"
                                        :url="this.$API_URL + 'list/lookup'" :minLength="0"
                                        :params="{ group: 'APPRAISAL_REPORT' }" />
                                </div>
                            </div>
                            <div class="field grid">
                                <label for="Name" class="col-4">{{ $t('name') }}</label>
                                <div class="col-8 md-8">
                                    <InputText name="Name" v-model="header.Name" required="true" type="text"
                                        :placeholder="$t('name')" />
                                </div>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="field grid">
                                <label for="Company_Code" class="col-4">{{ $t('company') }}</label>
                                <div class="col-8 md-8">
                                    <CustomMultiSelect class="p-inputtext-sm" v-model="CompanyCode" type="text"
                                        placeholder="All" :url="this.$API_URL + 'list/company_code'" :minLength="0"
                                        :params="{}" :filter="true" :optionValue="'id'" :optionLabel="'text'" />
                                </div>
                            </div>
                            <div class="field grid">
                                <label for="Division_Code" class="col-4">{{ $t('division') }}</label>
                                <div class="col-8 md-8">
                                    <CustomMultiSelect class="p-inputtext-sm" v-model="DivisionCode" type="text"
                                        placeholder="All" :url="this.$API_URL + 'list/division_code'" :minLength="0"
                                        :params="{}" :filter="true" :optionValue="'id'" :optionLabel="'text'" />
                                </div>
                            </div>
                            <div class="field grid">
                                <label for="Region" class="col-4">{{ $t('business_unit') }}</label>
                                <div class="col-8 md-8">
                                    <CustomMultiSelect class="p-inputtext-sm" v-model="Region" type="text"
                                        placeholder="All" :url="this.$API_URL + 'list/lookup'" :minLength="0"
                                        :params="{ group: 'REGION' }" :filter="true" :optionValue="'id'"
                                        :optionLabel="'text'" />
                                </div>
                            </div>
                            <div class="field grid">
                                <label for="Directorate_Code" class="col-4">{{ $t('directorate') }}</label>
                                <div class="col-8 md-8">
                                    <CustomMultiSelect class="p-inputtext-sm" v-model="DirectorateCode" type="text"
                                        placeholder="All" :url="this.$API_URL + 'list/directorate_code'" :minLength="0"
                                        :params="{}" :filter="true" :optionValue="'id'" :optionLabel="'text'" />
                                </div>
                            </div>
                            <div class="field grid">
                                <label for="Period_Year" class="col-4">{{ $t('appraisal_period') }}</label>
                                <div class="col-8 md-8">
                                    <Dropdown v-model="header.Period_Year" :options="years" optionLabel="value"
                                        optionValue="value" :placeholder="$t('year')" />
                                </div>
                            </div>
                            <div class="field grid">
                                <label for="source" class="col-4">{{ $t('source') }}</label>
                                <div class="col-8 md-8">
                                    <CustomSelect class="p-inputtext-sm" v-model="this.Source" :filter="true"
                                        :url="this.$API_URL + 'list/lookup'" :minLength="0" placeholder="All"
                                        :params="{ group: 'SOURCE' }" />
                                </div>
                            </div>
                            <div class="field grid">
                                <label for="Job_Status_Code" class="col-4">{{ $t('jobStatus') }}</label>
                                <div class="col-8 md-8">
                                    <CustomMultiSelect class="p-inputtext-sm" v-model="this.JobStatusCode" type="text"
                                        placeholder="All" :url="this.$API_URL + 'list/job_status_code'" :minLength="0"
                                        :params="{}" :filter="true" :optionValue="'id'" />
                                    <small v-if="!this.JobStatusCode || this.JobStatusCode == ''" class="p-error">
                                        {{ $t('default_jobstatus') }}
                                    </small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <Button type="button" label="Generate Appraisal Not Assessed" @click="generateUnassessed()"
                    icon="pi pi-external-link" />
                &nbsp;
                <Button type="button" label="Generate Appraisal Assessed (Uncategorized)"
                    @click="generateAssessedUncategorized()" icon="pi pi-external-link" class="p-button-help" />
                &nbsp;
                <Button type="button" label="Generate Appraisal Assessed (Categorized)"
                    @click="generateAssessedCategorized()" icon="pi pi-external-link" class="p-button-info" /> -->

                <Button type="button" label="Generate" @click="generate()" icon="pi pi-external-link" />
                &nbsp;

                <Button type="button" class="p-button-success" label="Export Excel" @click="exportExcel()"
                    v-show="this.reportTbl" icon="pi pi-file-excel" />
                <br /><br />
                <div id="tableContent" v-html="this.reportTbl.content" v-if="this.reportTbl"
                    style="overflow: auto;height: 100vh;" />
                <div id="printExcel" v-html="this.reportTbl.content" v-if="this.excelTbl" v-show="false" />

            </template>
        </Card>
    </form>

    <ReportAuth v-if="reportAuth" :isVisible="reportAuth" :initialErrorMessage="errormessage"
        @hide="hideReportAuthDialog" />
</template>

<script>
export default {
    data() {
        return {
            test: 0,
            mode: "",
            dataUrlUnassessed: "Report/appraisal_report_unassessed",
            dataUrlCategorized: "Report/appraisal_report_categorized",
            dataUrlUncategorized: "Report/appraisal_report_uncategorized",
            dataUrlAssessed: "",
            reportTbl: null,
            excelTbl: null,
            showReport: false,
            loadingReport: false,
            Error_Message: "",
            mergedOptions: [
                { label: "Y", value: 1 },
                { label: "N", value: 0 },
            ],
            UnitCode: null,
            FunctionalCode: null,
            DepartmentCode: null,
            GradeCode: null,
            SectionCode: null,
            CompanyCode: null,
            DivisionCode: null,
            JobStatusCode: null,
            Region: null,
            DirectorateCode: null,
            Source: null,
            Statuses: null,
            header: {
                Unit_Code: null,
                Functional_Code: null,
                Department_Code: null,
                Grade_Code: null,
                Section_Code: null,
                Company_Code: null,
                Division_Code: null,
                Job_Status_Code: null,
                Period_Year: new Date().getFullYear(),
                Region: null,
                Directorate_Code: null,
                Source: null,
                Name: "",
            },
            submitted: false,
            submitCategory: 0,
            Appraisal_Type: 'UNASSESSED',
            reportAuth: false
        };
    },
    methods: {
        reopenTab() {
            this.showReport = true;
        },
        resetBtn() {
            this.showReport = false;
        },
        tableToExcel() {
            this.loadingReport = !this.loadingReport;
        },
        generate() {
            if (this.Appraisal_Type == 'UNASSESSED')
                this.generateUnassessed();
            else if (this.Appraisal_Type == 'UNCATEGORIZED')
                this.generateAssessedUncategorized();
            else if (this.Appraisal_Type == 'CATEGORIZED')
                this.generateAssessedCategorized();
        },
        generateUnassessed() {
            this.Error_Message = "";

            if (this.validate()) {
                this.submitCategory = 1;
                this.header.Is_Export = false;
                this.getReport(this.dataUrlUnassessed);
            }
        },
        generateAssessedCategorized() {
            this.Error_Message = "";

            if (this.validate()) {
                this.submitCategory = 3;
                this.header.Is_Export = false;
                this.getReport(this.dataUrlCategorized);
            }
        },
        generateAssessedUncategorized() {
            this.Error_Message = "";

            if (this.validate()) {
                this.submitCategory = 2;
                this.header.Is_Export = false;
                this.getReport(this.dataUrlUncategorized);
            }
        },
        validate() {
            var result = true;

            if (!this.UnitCode && !this.FunctionalCode && !this.DepartmentCode && !this.GradeCode
                && !this.CompanyCode && !this.DivisionCode && !this.Region && this.header.Name == '' && !this.JobStatusCode && !this.Source) {
                result = false;
                this.Error_Message = "Pilih minimal 1 filter!";
            }

            return result;
        },
        setReportModel() {
            this.header.Unit_Code = this.UnitCode ? this.UnitCode.join(',') : '';
            this.header.Functional_Code = this.FunctionalCode ? this.FunctionalCode.join(',') : '';
            this.header.Department_Code = this.DepartmentCode ? this.DepartmentCode.join(',') : '';
            this.header.Grade_Code = this.GradeCode ? this.GradeCode.join(',') : '';
            this.header.Section_Code = this.SectionCode ? this.SectionCode.join(',') : '';
            this.header.Company_Code = this.CompanyCode ? this.CompanyCode.join(',') : '';
            this.header.Division_Code = this.DivisionCode ? this.DivisionCode.join(',') : '';
            this.header.Region = this.Region ? this.Region.join(',') : '';
            this.header.Directorate_Code = this.DirectorateCode ? this.DirectorateCode.join(',') : '';
            this.header.Job_Status_Code = this.JobStatusCode ? this.JobStatusCode.join(',') : '';
            this.header.Source = this.Source;
        },
        getReport(url) {
            this.$emit('block-ui');

            this.setReportModel();

            this.$axios.post(this.$API_URL + url, this.header)
                .then((response) => {
                    if (response.data.success) {
                        if (this.header.Is_Export) {
                            this.excelTbl = {
                                header: response.data.data.header,
                                content: response.data.data.content,
                                title: response.data.data.title,
                            };

                            if (this.submitCategory == 3) {
                                this.tableToExcelMultipleSheet();
                            }
                            else {
                                this.tableToExcel();
                            }

                        }
                        else {
                            this.reportTbl = {
                                header: response.data.data.header,
                                content: response.data.data.content,
                                title: response.data.data.title,
                            };

                            this.excelTbl = this.reportTbl;
                        }
                    }

                    this.$emit('unblock-ui');
                })
                .catch(() => {
                    this.$emit('unblock-ui');
                })
                .finally(() => {
                    // let pixel = document.getElementById('tableContent').childNodes[0].clientWidth + 20;
                    // document.getElementById('mainForm').style.width = '' + pixel + 'px';

                    var listData = document.getElementsByName("hidetemp");
                    listData.forEach((element) => {
                        element.style.display = "none";
                    });
                });
        },
        exportExcel() {
            this.Error_Message = "";

            // if(this.validate()){
            //     this.header.Is_Export = true;

            //     var url = "";

            //      if(this.submitCategory == 1){
            //         url = this.dataUrlUnassessed;
            //     }
            //     else if(this.submitCategory == 2){
            //         url = this.dataUrlUncategorized;
            //     }
            //     else if(this.submitCategory == 3){
            //         url = this.dataUrlCategorized
            //     }

            //     this.getReport(url);
            // }

            var listData = document.getElementsByName("hidetemp");
            listData.forEach((element) => {
                element.style.display = "block";
            });

            var copyListData = [];
            listData = document.getElementsByName("showtemp");
            listData.forEach((element) => {
                copyListData.push(element.textContent);
                element.textContent = '';
            });

            var listComment = document.getElementsByName("commentName");
            listComment.forEach((element) => {
                element.innerHTML = element.textContent;
            });

            if (this.submitCategory == 3) {
                // this.tableToExcelMultipleSheet();
                this.onExport();
            }
            else
                this.tableToExcel();

            listData = document.getElementsByName("hidetemp");
            listData.forEach((element) => {
                element.style.display = "none";
            });

            listData = document.getElementsByName("showtemp");
            listData.forEach((element, index) => {
                element.textContent = copyListData[index];
            });
        },
        tableToExcel() {
            var uri = "data:application/vnd.ms-excel;base64,",
                template =
                    '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/></head><body><table>{table}</table></body></html>',
                base64 = function (s) {
                    return window.btoa(unescape(encodeURIComponent(s)));
                },
                format = function (s, c) {
                    return s.replace(/{(\w+)}/g, function (m, p) {
                        return c[p];
                    });
                };
            var ctx = {
                worksheet: "Default" || "Worksheet",
                table: this.excelTbl.header + this.excelTbl.content,
            };
            var currentDate = this.$moment().format("DD-MM-yyyy_hh-mm");
            var fileName = this.excelTbl.title + "_" + currentDate;
            const link = document.createElement("a");
            link.href = uri + base64(format(template, ctx));
            link.download = fileName;
            link.click();
        },
        tableToExcelMultipleSheet() {
            var uri = 'data:application/vnd.ms-excel;base64,'
                , html_start = `<html xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40">`
                , template_ExcelWorksheet = `<x:ExcelWorksheet><x:Name>{SheetName}</x:Name><x:WorksheetSource HRef="sheet{SheetIndex}.htm"/></x:ExcelWorksheet>`
                , template_ListWorksheet = `<o:File HRef="sheet{SheetIndex}.htm"/>`
                , template_HTMLWorksheet = `
------=_NextPart_dummy
Content-Location: sheet{SheetIndex}.htm
Content-Type: text/html; charset=windows-1252

` + html_start + `
<head>
  <meta http-equiv="Content-Type" content="text/html; charset=windows-1252">
  <link id="Main-File" rel="Main-File" href="../WorkBook.htm">
  <link rel="File-List" href="filelist.xml">
</head>
<body>{SheetContent}</body>
</html>`
                , template_WorkBook = `MIME-Version: 1.0
X-Document-Type: Workbook
Content-Type: multipart/related; boundary="----=_NextPart_dummy"

------=_NextPart_dummy
Content-Location: WorkBook.htm
Content-Type: text/html; charset=windows-1252

` + html_start + `
<head>
<meta name="Excel Workbook Frameset">
<meta http-equiv="Content-Type" content="text/html; charset=windows-1252">
<link rel="File-List" href="filelist.xml">
<!--[if gte mso 9]><xml>
 <x:ExcelWorkbook>
  <x:ExcelWorksheets>{ExcelWorksheets}</x:ExcelWorksheets>
  <x:ActiveSheet>0</x:ActiveSheet>
 </x:ExcelWorkbook>
</xml><![endif]-->
</head>
<frameset>
  <frame src="sheet0.htm" name="frSheet">
  <noframes><body><p>This page uses frames, but your browser does not support them.</p></body></noframes>
</frameset>
</html>
{HTMLWorksheets}
Content-Location: filelist.xml
Content-Type: text/xml; charset="utf-8"

<xml xmlns:o="urn:schemas-microsoft-com:office:office">
  <o:MainFile HRef="../WorkBook.htm"/>
  {ListWorksheets}
  <o:File HRef="filelist.xml"/>
</xml>
------=_NextPart_dummy--
`
                , base64 = function (s) { return window.btoa(unescape(encodeURIComponent(s))) }
                , format = function (s, c) { return s.replace(/{(\w+)}/g, function (m, p) { return c[p]; }) }

            var context_WorkBook = {
                ExcelWorksheets: ''
                , HTMLWorksheets: ''
                , ListWorksheets: ''
            };

            var tables = document.getElementById('printExcel').getElementsByClassName('Appraisal');
            for (var SheetIndex = 0; SheetIndex < tables.length; SheetIndex++) {
                var e = tables[SheetIndex];

                var SheetName = e.getAttribute('data-SheetName');
                if (SheetName.trim() === '') {
                    SheetName = 'Sheet' + SheetIndex;
                }
                context_WorkBook.ExcelWorksheets += format(template_ExcelWorksheet, {
                    SheetIndex: SheetIndex
                    , SheetName: SheetName
                });
                context_WorkBook.HTMLWorksheets += format(template_HTMLWorksheet, {
                    SheetIndex: SheetIndex
                    , SheetContent: e.outerHTML
                });
                context_WorkBook.ListWorksheets += format(template_ListWorksheet, {
                    SheetIndex: SheetIndex
                });
            };

            var currentDate = this.$moment().format("DD-MM-yyyy_hh-mm");
            var fileName = "ListAssessed_" + currentDate;
            var link = document.createElement("A");
            link.href = uri + base64(format(template_WorkBook, context_WorkBook));
            link.download = fileName || 'Workbook.xls';
            link.click();
        },
        showError() {
            this.loadingReport = !this.loadingReport;
        },
        closeReport() {
            this.showReport = false;
        },
        showReportAuth() {
            this.reportAuth = true;
        },
        hideReportAuthDialog() {
            this.reportAuth = false;
        },
        onExport() {
            this.loading = true;
            var self = this;
            let UrlExport = "Report/export_appraisal_report_categorized"

            this.$axios.post(this.$API_URL + UrlExport, this.header, {
                responseType: 'blob'
            })
                .then((response) => {
                    var contentDisposition = response.headers["content-disposition"];
                    var matchName = contentDisposition.match(/filename\s*=\s*"?(.+)"?/);
                    var filename = matchName[1].split(';')[0];

                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', filename);
                    document.body.appendChild(link);
                    link.click();

                })
                .catch(function (err) {
                    self.$toast.add({ severity: 'error', summary: "Error", detail: err.message, life: self.$DEFAULT_TIMER });
                    self.loading = false;
                });

            setTimeout(() => {
                this.loading = false;
            }, 1000);
        },
    },
    mounted() { },
    computed: {
        years() {
            let years = [];
            for (var i = new Date().getFullYear(); i >= 2023; i--) {
                years.push({ value: i.toString() })
            }
            return years;
        },
    }
};
</script>
